import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { emailFlowsApi } from '../api/emailFlows.api'
import type { ContactoRow } from '../types'

export function useEmailFlows() {
  return useQuery({
    queryKey: ['email-flows'],
    queryFn: emailFlowsApi.listar,
  })
}

export function useEmailFlow(id: number) {
  return useQuery({
    queryKey: ['email-flow', id],
    queryFn: () => emailFlowsApi.obtener(id),
    enabled: !!id,
  })
}

export function useCrearFlujo() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: emailFlowsApi.crear,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['email-flows'] }),
  })
}

export function useActualizarFlujo(id: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (payload: Parameters<typeof emailFlowsApi.actualizar>[1]) =>
      emailFlowsApi.actualizar(id, payload),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['email-flows'] })
      qc.invalidateQueries({ queryKey: ['email-flow', id] })
    },
  })
}

export function useEliminarFlujo() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: emailFlowsApi.eliminar,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['email-flows'] }),
  })
}

export function useImportarContactos(flujoId: number) {
  return useMutation({
    mutationFn: (contactos: ContactoRow[]) =>
      emailFlowsApi.importarContactos(flujoId, contactos),
  })
}

export function useEjecutarFlujo() {
  return useMutation({
    mutationFn: emailFlowsApi.ejecutar,
  })
}
